import React from 'react';
import PropTypes from 'prop-types';

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import {ReactComponent as ArrowLeftIcon} from "assets/img/wms/arrow-left.svg";
import {greyishBlue50} from "assets/jss/main";
import {Card, CardContent} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
    return (
        <Slide
            direction="left"
            ref={ref}
            children={props.children}
            {...props}
        />
    );
});

RightDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    headerRightContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    headerLeftContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    headerCenterContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    footer: PropTypes.element,
    hideCloseIcon: PropTypes.bool,
    strictOnClose: PropTypes.bool
};

function RightDrawer({open, handleClose, headerLeftContent = null, headerRightContent = null, headerCenterContent = null, footer = null, hideCloseIcon = false, strictOnClose = false, ...props}) {
    return (
        <Dialog
            fullScreen
            open={open}
            onClose={strictOnClose ? (event, reason) => {
                    if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        onClose();
                    }
                } : handleClose}
            TransitionComponent={Transition}
            sx={{
                '& .MuiPaper-root ': {
                    backgroundColor: greyishBlue50,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }
            }}
        >
            <Grid
                container
                justifyContent={"space-between"}
                sx={{
                    padding: '20px 16px',
                    backgroundColor: '#fff',
                }}
            >
                {!hideCloseIcon && (
                    <Grid
                        item
                        container
                        xs={'auto'}
                        alignItems={'center'}
                        onClick={handleClose}
                    >
                        <React.Fragment>
                            <ArrowLeftIcon />
                            {headerLeftContent && headerLeftContent}
                        </React.Fragment>
                    </Grid>
                )}

                <Grid
                    item
                    container
                    xs={'auto'}
                    justifyContent={"end"}
                    alignItems={'center'}
                >
                    {headerCenterContent}
                </Grid>
                <Grid
                    item
                    container
                    xs={'auto'}
                    justifyContent={"end"}
                    alignItems={'center'}
                >
                    {headerRightContent}
                </Grid>
            </Grid>
            {props.children}
            {footer && (
                <Grid container>
                    <Card style={{
                        height: 'fit-content',
                        boxShadow: 'none',
                        borderBottom: `1px solid ${greyishBlue50}`,
                        width: '100%',
                        backgroundColor: 'white'
                    }}>
                        <CardContent>
                            {footer}
                        </CardContent>
                    </Card>
                </Grid>
            )}
        </Dialog>
    );
}

export default RightDrawer;
